import React from 'react';

import { Button, Icons, TextClamp } from '@components/common';

import { formatDate } from '@utils/date';

import { TNameTitle } from '@interfaces/common/common';

import { ERoles } from '../constants';

import styles from '../RequestReservationCard.module.scss';

interface IRequestDescriptionProps {
	requestId: string;
	comment?: string;
	isAttachDocuments?: boolean;
	attachedDocumentsCount?: number;
	creationDate: number;
	updateDate?: number;
	requestType: TNameTitle;
	isAbleToDecline: boolean;
	role: string;
	openDeclineModal: (comment?: string) => void;
	openAttachedDocuments: () => void;
}

const dateFormat = 'dd/MM/yyyy hh:mm a';

const RequestDescription = ({
	requestId,
	comment,
	creationDate,
	updateDate,
	requestType,
	isAbleToDecline = true,
	isAttachDocuments = false,
	attachedDocumentsCount = 0,
	role,
	openDeclineModal,
	openAttachedDocuments,
}: IRequestDescriptionProps) => {
	return (
		<div className={styles.requestDescription}>
			<div className={styles.requestDescriptionHeader}>
				<div className={styles.title}>Request ID {requestId}</div>
				<div className={styles.buttonsWrapper}>
					{isAttachDocuments && (
						<Button
							icon={Icons.clip()}
							onClick={openAttachedDocuments}
							secondary
							text={`View documents (${attachedDocumentsCount})`}
						/>
					)}
					{isAbleToDecline && (
						<Button
							onClick={openDeclineModal}
							text={role === ERoles.ao ? 'Decline' : 'Cancel'}
						/>
					)}
				</div>
			</div>
			<div
				className={styles.requestDescriptionList}
				data-testid='request-description'
			>
				<div className={styles.requestParamItem}>
					<span className={styles.requestParamName}>Created:</span>
					<span className={styles.requestParamValue}>{formatDate(creationDate, dateFormat)}</span>
				</div>
				{updateDate
					&& <div className={styles.requestParamItem}>
						<span className={styles.requestParamName}>Updated:</span>
						<span className={styles.requestParamValue}>{formatDate(updateDate, dateFormat)}</span>
					</div>
				}
				{requestType
					&& <div className={styles.requestParamItem}>
						<span className={styles.requestParamName}>Type:</span>
						<span className={styles.requestParamValue}>{requestType.title}</span>
					</div>
				}
				<div className={styles.requestDescriptionComment}>
					<div className={styles.requestParamName}>Comment:</div>
					<div>
						<TextClamp
							clampedTextClassname={styles.requestParamValue}
							text={comment || ''}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RequestDescription;
